import { usePutMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<z.ZodUndefined, z.ZodUndefined>
>[3];

export const useMarkSubCategoryAsCompleted = (
  subCategoryId: string,
  config?: Config,
) => {
  return usePutMutation(
    z.undefined(),
    z.undefined(),
    `/app/assessment/answer_sub_categories/${subCategoryId}/mark_as_completed`,
    config,
  );
};
